import React from 'react'

export default function HomeNav() {
    function link (e, el){
  
        document.getElementById(el).scrollIntoView({smooth:true})
    }
  return (
    <nav className="center">
        <div className="link active"onClick={(e)=>link(e, "Populare")}>Populare</div>
        <div  className="link" onClick={(e)=>link(e,"Vegetarian")}>Vegetarian</div>
        <div className="link" onClick={(e)=>link(e,"Dessert")}>Sweets</div>
    </nav>
  )
}
